import { Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react'
import { DireccionesContext } from '../../pages/catalogos/DireccionesPage';
import { TablaDireccionComponent } from './TablaDireccionComponent';
export const TablaDireccionesComponent = () => {
    const {obtenerDirecciones, direcciones} = useContext(DireccionesContext)



    useEffect(() => {
        obtenerDirecciones();
    }, [])

    useEffect(() => {
        console.log('direcciones', direcciones);
    }, [direcciones])
        

  return (
    <div
        style={{
            display:'flex',
            flexDirection:'row'
        }}
    >
        <div
            style={{
                display:'flex',
                flexDirection:'column',
                flex:50
            }}
        >
            <div
                style={{
                    display:'flex',
                    flexDirection:'row',
                    backgroundColor:'white',
                    padding:5,
                    borderRadius:20,
                    flex:1,
                    fontWeight:'bold'
                }}
            >
                <Typography style={{fontSize:14, fontWeight:'bold',flex:15}} >Dirección</Typography>
                <Typography style={{fontSize:14, fontWeight:'bold',flex:15}}>Nombre Corto</Typography>
                <Typography style={{fontSize:14, fontWeight:'bold',flex:15}}>Responsable</Typography>
                <Typography style={{fontSize:14, fontWeight:'bold',flex:5}}></Typography>
            </div>
            {
                direcciones?.map(direccion=> (
                    <div
                        key={direccion.IdDireccion}
                        style={{
                            display:'flex',
                            flexDirection:'row',
                            backgroundColor:'white',
                            padding:5,
                            borderRadius:20,
                            flex:1,
                            fontWeight:'bold',
                            marginTop:5,
                        }}
                    >
                        <TablaDireccionComponent obtenerDirecciones={obtenerDirecciones} direccion={direccion} />
                    </div>
                ))
            }

        </div>
        <div
            style={{
                display:'flex',
                flexDirection:'column',
                flex:30
            }}
        >
        </div>
    </div>
  )
}

const styles = {
    tablaEncabezado: {
        fontSize:14,
        fontWeight:'bold'
    },
    flex15: {
        flex:15
    }
}

